import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { MEDIA_QUERY, useResponsive } from '@bucketplace/design-system';
import {
  Divider,
  Grid,
  GridItem,
} from '@bucketplace/design-system/bds';

import { ExhibitionProductCard } from '../ExhibitionProductCard';
import { ExhibitionList } from './types';

export function TwoColList({
  disableVerticalPadding,
  storeItemList,
  badgeType,
  useBuyButton,
  logData,
}: ExhibitionList): ReactElement {
  const { breakpoint } = useResponsive({});
  const isMobile = breakpoint === 'mobile';
  const showDivider = isMobile && useBuyButton;

  return (
    <Container
      disableVerticalPadding={disableVerticalPadding}
      gap={{
        laptop: '20 20',
        mobile: '20 15',
      }}
    >
      { storeItemList.map((storeItem, index) => (
        <GridItem
          key={storeItem.id}
          column={isMobile ? 'half' : 'quarter'}
          // 구매하기 버튼은 항상 카드 아래쪽에 위치
          // 배너 뱃지는 카드 상단을 덮기 때문에 baseline 설정
          style={{
            alignSelf: !useBuyButton && badgeType === 'banner' ? 'baseline' : undefined,
          }}
        >
          <CardWrapper>
            <ExhibitionProductCard
              product={storeItem}
              badgeType={badgeType}
              textBadgeList={storeItem.textBadgeList}
              useBuyButton={useBuyButton}
              href={storeItem.getStoreItemHref?.(storeItem.id)}
              linkComponent={storeItem.linkComponent}
              logData={{
                ...logData,
                index,
              }}
            />
            { showDivider && <StyledDivider variant="thin" /> }
          </CardWrapper>
        </GridItem>
      )) }
    </Container>
  );
}

const Container = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'disableVerticalPadding',
})<{ disableVerticalPadding?: boolean }>`
  padding: ${(props) => props.disableVerticalPadding ? 0 : '10px 0'};
  overflow: visible;
  > div:first-of-type {
    display: flex;
    flex-wrap: wrap;
  }
  ${MEDIA_QUERY.max('tablet', `
    padding: 10px 16px;
    overflow: hidden;
  `)}
`;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledDivider = styled(Divider)`
  margin: 25px -20px 0 -20px;
`;
